import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JobType } from './job';
import { AccountSettingsViews } from '../components/core/settings-sidebar/settings-sidebar';

export enum OutOfSyncState {
    LearningClassifier = 'Learning Classifier',
    StaticClassifier = 'Static Classifier',
    AnomalyRecognizer = 'Anomaly Recognizer',
    AnomalyHiFi = 'Anomaly Hi-Fi',
    WhiteLabelLearningClassifier = 'Working Brain',
    WhiteLabelStaticClassifier = 'Firefly DL Brain',
    Detector = 'Detector'
}

export enum SidebarClass {
    'EXPANDED' = 'has-expanded-navbar',
    'COLLAPSED' = 'has-collapsed-navbar'
}

export interface PageMetadata {
    hasNavbar: boolean;
    projectIdentifier?: string;
    datasetIdentifier?: string;
    isSettingsPage: boolean;
    settingsView?: AccountSettingsViews | string;
}

@Injectable()
export class NavSidebarProvider {
    private _currentMetadata: PageMetadata;
    get currentMetadata(): PageMetadata {
        return this._currentMetadata;
    }
    set currentMetadata(metadata: PageMetadata) {
        this._currentMetadata = metadata;
        this.currentMetadataSubscription.next(this._currentMetadata);
    }
    public currentMetadataSubscription: BehaviorSubject<PageMetadata | undefined> = new BehaviorSubject(undefined);

    private contentClass: SidebarClass = SidebarClass.EXPANDED;
    public contentClassSubscription: BehaviorSubject<SidebarClass> = new BehaviorSubject<SidebarClass>(
        SidebarClass.EXPANDED
    );

    constructor() {}

    public getContentClass(): SidebarClass {
        return this.contentClass;
    }

    public setContentClass(contentClass: SidebarClass): void {
        this.contentClass = contentClass;
        this.contentClassSubscription.next(this.contentClass);
    }

    /**
     * Return a boost job type associated with the specified outOfSyncState,
     * indicating which type of job will bring the brain version type
     * back into sync
     */
    public getJobTypeForOutOfSyncState(outOfSyncState: OutOfSyncState): JobType {
        switch (outOfSyncState) {
            case OutOfSyncState.AnomalyRecognizer:
            case OutOfSyncState.LearningClassifier:
            case OutOfSyncState.WhiteLabelLearningClassifier:
                return JobType.Retrain;
            case OutOfSyncState.Detector:
                return JobType.Train;
            case OutOfSyncState.WhiteLabelStaticClassifier:
            case OutOfSyncState.StaticClassifier:
                return JobType.Freeze;
        }

        throw new Error(`getJobTypeForOutOfSyncState() does not support OutOfSyncState ${outOfSyncState}`);
    }
}



// WEBPACK FOOTER //
// ./src/providers/nav-sidebar.ts